exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".upload {\n  position: relative;\n}\n\n.upload input.file {\n  display: none;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/resolve-url-loader!/~/sass-loader!./app/assets/css/sass/components/upload.scss
// module id = 593
// module chunks = 0